export const HOME_PAGE = '/';
export const LOGIN = '/dang-nhap';
export const ADS = '/ads';
export const INS = '/ins';
export const SIGNUP = '/dang-ky';
export const INFO = '/info';
export const DICH_VU = '/dich-vu';
export const TINH_NANG = '/tinh-nang';
export const DI_DONG = '/di-dong';
export const GTGT = '/GTGT';
export const INTERNET_TV = '/internet-tv';
export const SEARCH = '/tim-kiem';
export const VINAPHONE_PLUS = '/vinaphone+';
export const APP_REDIRECT = '/app';
export const VIEW_PDF = '/view-pdf';
export const TTTB = '/tttb';
export const CNTTTB = '/cap-nhat-tt';
export const LANDING_PAGE = '/thongtinthuebao';
export const CTKMJ2K = '/sieuvoucher50';
